// Represents the state of an async operation as a single tagged value,
// instead of separate isLoading / hasError / data flags that could
// contradict each other.

// T is a generic placeholder for the data's type, inferred from the
// argument passed in (e.g. asyncSuccess(42) makes T = number), so the
// returned AsyncState<T> keeps that same type instead of using `any`.

export type AsyncState<T> =
  | { status: 'loading' } // request in flight, no data yet
  | { status: 'error' } // request failed, no data
  | { status: 'success'; data: T } // request succeeded, data is available

// Use when starting the async operation.
export const asyncLoading = <T>(): AsyncState<T> => ({ status: 'loading' })
// Use when the async operation fails.
export const asyncError = <T>(): AsyncState<T> => ({ status: 'error' })
// Use when the async operation succeeds, with its result.
export const asyncSuccess = <T>(data: T): AsyncState<T> => ({ status: 'success', data })
